import { useT } from "../context/LangContext";

const LANGS = [
  { code: "it", label: "ITA" },
  { code: "en", label: "ENG" },
  { code: "es", label: "ESP" },
  { code: "fr", label: "FRA" },
];

export const LanguageToggle = ({ className = "", variant = "desktop" }) => {
  const { lang, setLang } = useT();
  return (
    <div className={`inline-flex items-center rounded-full border border-ink/15 p-0.5 text-xs font-bold ${className}`} data-testid={`lang-toggle-${variant}`}>
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}-${variant}`}
          onClick={() => setLang(l.code)}
          className={`px-2 py-1 rounded-full transition-colors duration-200 ${lang === l.code ? "bg-terracotta text-white" : "text-ink/70 hover:text-ink"}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};
